export class DuplicateCourtSystemNameError extends Error {
  constructor() {
    super('A Court System with this name already exists')
    Object.setPrototypeOf(this, DuplicateCourtSystemNameError.prototype)
  }
}
